(function () {
  function chatHost() {
    return (
      document.querySelector("shopify-chat") ||
      document.querySelector("inbox-online-store-chat") ||
      document.getElementById("ShopifyChat") ||
      document.querySelector("#shopify-chat")
    );
  }

  function clickToggle(root) {
    if (!root) return false;
    var btn = root.querySelector(
      "button.chat-toggle, .chat-toggle, .chat-app > button, button[aria-controls], button"
    );
    if (!btn) return false;
    btn.click();
    return true;
  }

  function openInbox() {
    var host = chatHost();
    if (!host) return false;
    try {
      if (typeof host.show === "function") {
        host.show();
        return true;
      }
      if ("open" in host) {
        host.open = true;
        if (host.open) return true;
      }
    } catch (err) {}
    if (host.shadowRoot && clickToggle(host.shadowRoot)) return true;
    if (clickToggle(host)) return true;
    return false;
  }

  function waitForHost(done) {
    var finished = false;
    function finish(ok) {
      if (finished) return;
      finished = true;
      done(ok);
    }
    if (openInbox()) {
      finish(true);
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (openInbox()) {
        clearInterval(timer);
        finish(true);
      } else if (tries >= 20) {
        clearInterval(timer);
        finish(false);
      }
    }, 200);
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined("shopify-chat").then(function () {
        if (openInbox()) {
          clearInterval(timer);
          finish(true);
        }
      });
    }
  }

  document.addEventListener(
    "click",
    function (e) {
      var link = e.target.closest("[data-ushare-chat]");
      if (!link) return;
      e.preventDefault();
      e.stopPropagation();
      waitForHost(function (ok) {
        if (!ok) window.location.href = link.getAttribute("href") || (window.ushareUrl || String)("/free-quote");
      });
    },
    true
  );
})();
